import React, { useEffect } from "react";
import "./index.css";

function AccessRequest({ name, microFrontendUrl, application }) {
  let containerName = `${name}-container`;
  useEffect(() => {
    const scriptId = `micro-frontend-script-${name}`;
    const overrideFunction = () => {
      if (document.getElementById("neo-authz-access-request-micro-frontend-link")) {
        document
          .getElementById("neo-authz-access-request-micro-frontend-link")
          .setAttribute(
            "neo-authz-access-request-micro-frontend-tooltip",
            "Requesting for access will raise a request for the dashboard(s)"
          );
      }
      if (document.getElementById("neo-authz-access-request-micro-frontend-modal-title")) {
        let modalTitle = document.querySelectorAll(
          "#neo-authz-access-request-micro-frontend-modal-title"
        );
        modalTitle[modalTitle.length - 1].innerHTML = "Request Access";
      }
      if (
        document.getElementById("neo-authz-access-request-micro-frontend-modal-title-description")
      ) {
        let modalTitleDescription = document.querySelectorAll(
          "#neo-authz-access-request-micro-frontend-modal-title-description"
        );
        modalTitleDescription[modalTitleDescription.length - 1].innerHTML =
          "Requesting for access will raise a request for the dashboard(s)";
      }
      if (document.getElementById("neo-authz-access-request-micro-frontend-button")) {
        document.getElementById("neo-authz-access-request-micro-frontend-button").innerHTML =
          "Request Access";
      }
      if (
        document.getElementById(
          "neo-authz-access-request-micro-frontend-textbox-reason-description"
        )
      ) {
        let reasonTextBoxDescription = document.querySelectorAll(
          "#neo-authz-access-request-micro-frontend-textbox-reason-description"
        );
        reasonTextBoxDescription[reasonTextBoxDescription.length - 1].innerHTML =
          "Paste the names of the dashboards you need access to and please mention your current primary function  , accepts 1-1000";
      }
    };

    const renderMicroFrontend = () => {
      const accessToken = window.getOktaAccessToken();
      let options = {
        containerId: containerName,
        application: application,
        accessToken: accessToken,
        hideButtonIcon: false,
        documentOverrideFunction: overrideFunction,
      };
      window[`render${name}`] && window[`render${name}`](options);
    };

    if (document.getElementById(scriptId)) {
      renderMicroFrontend();
      return;
    } else {
      const script = document.createElement("script");
      script.id = scriptId;
      script.crossOrigin = "";
      script.onload = () => {
        renderMicroFrontend();
      };
      script.src = `${microFrontendUrl}`;
      document.head.appendChild(script);
    }

    return () => {
      let options = {
        containerId: containerName,
      };
      window[`unmount${name}`] && window[`unmount${name}`](options);
    };
  });

  return <span id={containerName} />;
}

export default AccessRequest;
